//	Dependencies
import React from 'react';
import { useRouter } from 'next/router';

// App
import { KeyForgeView } from 'src/ui/views/ApepeOdyssey';
import { Layout } from 'ui/app';



//
//	RAYC / Pages / Apepe Odyssesy / Key Forge Page
//

export default function ApepeOdysseyKeyForge( props ) {
	const router = useRouter();
	const { query } = router;
	const viewForged = query.viewForged === 'true';
	return <KeyForgeView {...props}
		viewForged={viewForged} />;
}

const ApepeLayout = () => {
	return (
		<Layout footerVariation="secondary"
			includeInPage={true}>
			<ApepeOdysseyKeyForge />
		</Layout>
	);
};

ApepeOdysseyKeyForge.Layout = ApepeLayout;

export async function getStaticPaths() {
	// Here you should fetch or define the list of chapterIds that are available.
	// This could come from an API, database, or a local array, depending on your data source.
	
	const chapterIds = ['1'];
	
	// Map these chapterIds to an array of objects with params
	const paths = chapterIds.map( ( chapterId ) => {
		return {
			params: { chapterId: chapterId },
		};
	});
  
	return {
		paths,
		fallback: false, // or 'blocking' depending on your use case
	};
}

export async function getStaticProps({ params }) {
	// Fetch data for the specific chapter based on params.chapterId
	const chapterId = params.chapterId;
    
	return {
		props: {
			chapterId,
		},
	};
}
